import script from "./Footer.vue?vue&type=script&lang=ts&setup=true"
export * from "./Footer.vue?vue&type=script&lang=ts&setup=true"

import "./Footer.vue?vue&type=style&index=0&id=30b05fb4&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/pro-cloudapp-租户用户端网站-html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30b05fb4"]])

export default __exports__